import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-financial-health-feature',
  templateUrl: './financial-health-feature.component.html',
  styleUrls: ['./financial-health-feature.component.scss']
})
export class FinancialHealthFeatureComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() base = 0;
  @Input() current = 0;

  constructor() {}
}
